import clsx from 'clsx';
import React from 'react';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import ReactPaginate from 'react-paginate';

interface PaginationProps {
  initialPage?: number;
  pageCount: number;
  className?: string;
  onPageChange: (data: any) => void;
}

export const Pagination: React.FC<PaginationProps> = (props) => {
  const { pageCount, initialPage = 0, className = '', onPageChange } = props;
  if (pageCount <= 1) return null;

  return (
    <ReactPaginate
      initialPage={initialPage}
      previousLabel={<IoIosArrowBack size={26} />}
      nextLabel={<IoIosArrowForward size={26} />}
      breakLabel={'...'}
      pageCount={pageCount}
      marginPagesDisplayed={1}
      pageRangeDisplayed={2}
      onPageChange={onPageChange}
      containerClassName={clsx('pagination', { [className]: className })}
      pageClassName="pagination-page"
      breakClassName="pagination-break"
      previousClassName="pagination-prev pagination-direction"
      nextClassName="pagination-next pagination-direction"
    />
  );
};
